<template>
    <v-app-bar v-if="loggedIn" color="#2e3c56" app>
        <v-row justify="end">
            <v-app-bar-nav-icon large dark @click="toggleDrawer()"/>
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text color="white">
                        {{ user.name ? user.name : user.email }}
                        <v-icon
                            right
                            dark
                        >
                            mdi-arrow-down
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item link @click="logOut">
                        <v-list-item-icon>
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Log out</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>

        </v-row>
    </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    name: 'AppBar',
    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('auth', ['loggedIn']),
    },
    methods: {
        ...mapActions('auth', ['logOut']),
        ...mapMutations('app', ['toggleDrawer']),
    },
};
</script>

<style scoped>

</style>